export default __webpack_public_path__ + "static/media/modal-warning-icon.d8dcd5db.svg";